let wid = $WR.define('cheetahApplication/form/DesignerDictSelectField', [], function (require, exports, module) {
  const HTML = `
  <div class="x-field-editor">
    <div class="basic-editor"></div>
    <div class="form-group">
        <label>数据字典</label>
        <input name="dictionaryName" type="text" style="width: 120px" readonly>
        <input name="dictionary" type="hidden" class="form-control">
        <input name="dictionaryAppId" type="hidden" class="form-control">
        <button class="x-cmd-select-dict">选择</button>
    </div>
    <div class="controls">
       <div class="checkbox">
           <label><input name="enableInput" data-type="boolean" type="checkbox" value="true">是否可输入</label>
       </div>
   </div>
    <div class="style-editor"></div>
</div>
  `;
  var WidgetClass = require('cheetahApplication/form/DictSelectField');
  let Comp = MW.extend(require('designer/form/default/Base'), {
    defaults: {
      xtype: 'DictSelectField',
      xtypeName: '字典选择',
      isFormField: true
    },
    _getTpl: function () {
      return $(HTML)
    },
    getTargetWidgetClass: function () {
      return WidgetClass;
    }
  });

  module.exports = Comp;

});
$WR.defineType({
  id: wid,
  xtype: 'DesignerDictSelectField',
  designer: ''
});

wid = $WR.define('cheetahApplication/form/DictSelectField', [], function (require, exports, module) {
  const HTML = `
          <div class="x-imbedded-selection">
            <span class="value"></span>
            <a class="button">选择</a>
        </div>
        `
  const inputHtml = `<div class="input-group">
          <input type="text" class="form-control" autocomplete="off" {attrs:attributes}/>
          <a class="input-group-addon button" style='color:blue;border-color: white;background-color: white;'>选择</a>
        </div>`
  //form/default/Field
  let Comp = MW.extend(require('form/default/InputField'), {
    protectedDefaults: {
      btnLabel: '选择',
      isFormField: true
    },
    _renderBody: function () {
      let html = HTML;
      let enableInput = this.$dd.enableInput;
      if (enableInput) {
        html = inputHtml
      }
      let el = $(html);
      let me = this;
      el.find("a.button").click(function () {
        me.getDict().then(data => {
          PF.treeSelect({data}, function (obj) {
            me._value = obj.id;
            if (enableInput) {
              var inputObj = el.find("input");
              inputObj.val(inputObj.val() + obj.name);
            } else {
              el.find(".value").text(obj.name);
            }
          })
        });
      });
      me.el = el;
      return el;
    },
    getDict() {
      let me = this;
      if (me._dictValues) {
        return Promise.resolve(me._dictValues);
      }
      let dd = me.getDD();
      return PF.api.data.getDict(dd.dictionary, {applicationId: dd.dictionaryAppId}).then(res => {
        if (res.result && res.result.value) {
          me._dictValues = res.result.value.split(",").map(v => {
            let arr = v.split("|");
            return {id: arr[1], name: arr[0]}
          });
          return me._dictValues;
        }
      });
    },
    _getValue(v) {
      var me = this;
      if (me.isTextMode()) {
        return v;
      }
      if (me.$dd.enableInput) {
        if (me.__readered) {
          return me.el.find("input").val();
        } else {
          me.__readered = true;
          me.el.find("input").val((v || ""));
          return v;
        }
      }
      var ret = me._value || v;
      return ret;
    },
    getDisplayValue: function () {
      let me = this;
      if (me.$dd.enableInput) {
        return me.el.find("input").val();
      } else {
        return me.el.find(".value").text();
      }
    },
    _setValue(v, disableEvent, values) {
      let me = this;

      if (this.$dd.enableInput) {
        if (me.isTextMode()) {
          me.el.find(".x-field-text-mode-body").text(v);
        } else {
          me.el.find("input").val(v);
          me.__bd[me._getInputName(me.$dd)] = v;
        }
      } else {
        me.getDict().then(data => {
          let ds = me._dictValues || data;
          if (ds) {
            let d = ds.filter(d => {
              return d.id === v
            })[0];
            if (d) {
              me._value = d.id;
              if (me.isTextMode()) {
                me.el.find(".x-field-text-mode-body").text(v);
              } else {
                me.el.find(".value").text(d.name);
              }
              me.__bd[me._getInputName(me.$dd)] = me._value;
            }
          }
        });
      }
    }
  });
  module.exports = Comp;
});

$WR.defineType({
  id: wid,
  xtype: 'DictSelectField',
  designer: 'DesignerDictSelectField'
});



// WEBPACK FOOTER //
// ./src/common/formWidget/DictSelectField.js